var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CorporateNavigation", { attrs: { ActivePage: "dashboard" } }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container-fluid",
              staticStyle: { "margin-top": "80px", "padding-top": "20px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v("Enterprise Plan: " + _vm._s(_vm.rm.ScenarioName)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "h1",
                    {
                      staticStyle: {
                        "font-size": "2em",
                        "font-weight": "300",
                        color: "#33475b",
                        margin: "0",
                      },
                    },
                    [_vm._v("Projects")]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-lg-6 d-flex flex-column justify-content-end",
                  },
                  [_c("ScenarioNavigation")],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "row mt-5" }, [
                _c("div", { staticClass: "col-lg-6 col-md-12" }, [
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-header" }, [
                      _c("div", { staticClass: "float-right" }, [
                        _c("div", { staticClass: "dropdown d-inline mr-2" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary btn-sm",
                              attrs: { "data-toggle": "dropdown" },
                            },
                            [_vm._v("Legend")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-menu dropdown-menu-right",
                              attrs: { role: "menu" },
                            },
                            _vm._l(_vm.rm.Portfolios, function (p) {
                              return _c(
                                "span",
                                {
                                  key: p.Id,
                                  staticClass: "dropdown-item-text",
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-circle",
                                    style: { color: p.Color },
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(p.Name) +
                                      "\n                                    "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("h5", [_vm._v("Efficient Frontier")]),
                    ]),
                    _vm._v(" "),
                    _vm._m(0),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-lg-6 col-md-12" }, [
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-header" }, [
                      _c("div", { staticClass: "float-right" }, [
                        _c("div", { staticClass: "dropdown d-inline mr-2" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary btn-sm",
                              attrs: { "data-toggle": "dropdown" },
                            },
                            [_vm._v("Legend")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-menu dropdown-menu-right",
                              attrs: { role: "menu" },
                            },
                            _vm._l(_vm.rm.Portfolios, function (p) {
                              return _c(
                                "span",
                                {
                                  key: p.Id,
                                  staticClass: "dropdown-item-text",
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-circle",
                                    style: { color: p.Color },
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(p.Name) +
                                      "\n                                    "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("h5", [_vm._v("Prioritization Matrix")]),
                    ]),
                    _vm._v(" "),
                    _vm._m(1),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("br"),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("div", { staticClass: "table-responsive" }, [
                  _c("table", { staticClass: "table table-hover" }, [
                    _c("thead", [
                      _c("tr", [
                        _c(
                          "th",
                          {
                            staticClass: "align-middle",
                            staticStyle: {
                              "min-width": "300px",
                              width: "300px",
                              "max-width": "300px",
                            },
                          },
                          [_vm._v("Project")]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticClass: "text-center align-middle",
                            staticStyle: {
                              "min-width": "100px",
                              width: "100px",
                              "max-width": "100px",
                            },
                          },
                          [_vm._v("P&L")]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticClass: "text-center align-middle",
                            staticStyle: {
                              "min-width": "250px",
                              width: "250px",
                              "max-width": "250px",
                            },
                          },
                          [_vm._v("Portfolio")]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticClass: "text-center align-middle",
                            staticStyle: {
                              "min-width": "200px",
                              width: "200px",
                              "max-width": "200px",
                            },
                          },
                          [
                            _vm._v("Cost of value point "),
                            _c("br"),
                            _vm._v(" (" + _vm._s(_vm.rm.CurrencyLabel) + ")"),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticClass: "text-right align-middle",
                            staticStyle: {
                              "min-width": "250px",
                              width: "auto",
                            },
                          },
                          [
                            _vm._v("Costs "),
                            _c("br"),
                            _vm._v(" (" + _vm._s(_vm.rm.CurrencyLabel) + ")"),
                          ]
                        ),
                        _vm._v(" "),
                        _vm._m(2),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.projectsView, function (a) {
                        return _c("tr", { key: a.Id }, [
                          _c(
                            "td",
                            {
                              staticStyle: {
                                "min-width": "300px",
                                width: "300px",
                                "max-width": "300px",
                              },
                            },
                            [
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "sanitizedHref",
                                      rawName: "v-sanitizedHref",
                                      value: `/#/portfolio/alternative/dashboard/${a.PortfolioWorkspaceId}/${a.PortfolioTchProjectId}/${a.Id}`,
                                      expression:
                                        "`/#/portfolio/alternative/dashboard/${a.PortfolioWorkspaceId}/${a.PortfolioTchProjectId}/${a.Id}`",
                                    },
                                  ],
                                  staticClass: "text-primary",
                                },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(a.Name) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-center align-middle",
                              staticStyle: {
                                "min-width": "100px",
                                width: "100px",
                                "max-width": "100px",
                              },
                            },
                            [
                              a.HasActivePlan
                                ? _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "sanitizedHref",
                                          rawName: "v-sanitizedHref",
                                          value: `/#/q/project/pnl/${a.PortfolioWorkspaceId}/${a.PortfolioTchProjectId}/${a.Id}`,
                                          expression:
                                            "`/#/q/project/pnl/${a.PortfolioWorkspaceId}/${a.PortfolioTchProjectId}/${a.Id}`",
                                        },
                                      ],
                                      staticClass: "text-primary",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    View\n                                "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "sanitizedHref",
                                          rawName: "v-sanitizedHref",
                                          value: `/q/project/summary/${a.PortfolioWorkspaceId}/${a.PortfolioTchProjectId}/${a.Id}`,
                                          expression:
                                            "`/q/project/summary/${a.PortfolioWorkspaceId}/${a.PortfolioTchProjectId}/${a.Id}`",
                                        },
                                      ],
                                      staticClass: "text-danger",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    Not available\n                                "
                                      ),
                                    ]
                                  ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-center align-middle",
                              staticStyle: {
                                "min-width": "250px",
                                width: "250px",
                                "max-width": "250px",
                              },
                            },
                            [
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "sanitizedHref",
                                      rawName: "v-sanitizedHref",
                                      value: `/#/portfolio-plan/selection/${a.PortfolioWorkspaceId}/${a.PortfolioTchProjectId}/${a.ScenarioId}`,
                                      expression:
                                        "`/#/portfolio-plan/selection/${a.PortfolioWorkspaceId}/${a.PortfolioTchProjectId}/${a.ScenarioId}`",
                                    },
                                  ],
                                  staticClass: "text-primary",
                                },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(a.PortfolioName) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-center align-middle",
                              staticStyle: {
                                "min-width": "200px",
                                width: "200px",
                                "max-width": "200px",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.fmtNum(a.CostOfValuePoint)) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-right align-middle",
                              staticStyle: {
                                "min-width": "250px",
                                width: "auto",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "progress justify-content-end",
                                  staticStyle: { height: "30px" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "progress-bar bg-danger",
                                      style: {
                                        width: a.NormalizedTotalCost + "%",
                                      },
                                      attrs: { role: "progressbar" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(_vm.fmtNum(a.TotalCost)) +
                                          "\n                                    "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "align-middle",
                              staticStyle: {
                                "min-width": "250px",
                                width: "auto",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "progress",
                                  staticStyle: { height: "30px" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "progress-bar bg-success",
                                      style: { width: a.TotalValue + "%" },
                                      attrs: { role: "progressbar" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(_vm.fmtNum(a.TotalValue)) +
                                          "\n                                    "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ])
                      }),
                      0
                    ),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "card-body chart-container" }, [
      _c("div", {
        staticStyle: { "max-width": "100%", height: "100%", overflow: "auto" },
        attrs: { id: "Chart-EfficientFrontier" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "card-body chart-container" }, [
      _c("div", {
        staticStyle: { "max-width": "100%", height: "100%", overflow: "auto" },
        attrs: { id: "Chart-PrioritizationMatrix" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "th",
      {
        staticClass: "align-middle",
        staticStyle: { "min-width": "250px", width: "auto" },
      },
      [_vm._v("Value "), _c("br"), _vm._v(" (0-100)")]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }